module.exports = __webpack_public_path__ + "img/avatar4.31450070.png";